import { KnowledgePage } from "@/components/Knowledge/KnowledgePage";

export function Knowledge() {
  return <KnowledgePage />;
}
